/**
 * @ngdoc object
 * @name dashboard
 * @description
 *
 */
angular
    .module('festzelt-os.dashboard', [
        'ui.router',
        'festzelt-os.components',
        'festzelt-os.theme.festzelt-os'
    ]);

require('./dashboard-routes.js');

// Components
require('./components/default/component');
require('./components/oktoberfest-dashboard/component');
require('./components/schuetzenfestzelt-dashboard/component');

// Controllers
require('./controllers/dashboard-controller');

// Directives
require('./directives/dashboard-barchart-simple-directive');
require('./directives/dashboard-sex-directive');
require('./directives/dashboard-tabular-simple-directive.tpl.html');



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/dashboard-module.js